/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { DokumentAktualisierenRequest } from '../model/dokumentAktualisierenRequest';
// @ts-ignore
import { DokumentBerechtigungMultiRequest } from '../model/dokumentBerechtigungMultiRequest';
// @ts-ignore
import { DokumentBerechtigungRequest } from '../model/dokumentBerechtigungRequest';
// @ts-ignore
import { DokumentEntfernenRequest } from '../model/dokumentEntfernenRequest';
// @ts-ignore
import { DokumentHinzufuegenRequest } from '../model/dokumentHinzufuegenRequest';
// @ts-ignore
import { DokumentIdentifier } from '../model/dokumentIdentifier';
// @ts-ignore
import { DokumentUploadAktualisierenRequest } from '../model/dokumentUploadAktualisierenRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class DokumenteCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostDokumentAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/aktualisieren
     * @param dokumentAktualisierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentAktualisieren(dokumentAktualisierenRequest: DokumentAktualisierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentAktualisierenRequest === null || dokumentAktualisierenRequest === undefined) {
            throw new Error('Required parameter dokumentAktualisierenRequest was null or undefined when calling postDokumentAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentAktualisierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/bearbeiten/entfernen
     * @param dokumentBerechtigungRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRequest === null || dokumentBerechtigungRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRequest was null or undefined when calling postDokumentBearbeitenBerechtigungEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/bearbeiten/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/bearbeiten/entfernen/multi
     * @param dokumentBerechtigungMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungMultiRequest === null || dokumentBerechtigungMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungMultiRequest was null or undefined when calling postDokumentBearbeitenBerechtigungEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/bearbeiten/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen
     * @param dokumentBerechtigungRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRequest === null || dokumentBerechtigungRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRequest was null or undefined when calling postDokumentBearbeitenBerechtigungHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBearbeitenBerechtigungHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen/multi
     * @param dokumentBerechtigungMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBearbeitenBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungMultiRequest === null || dokumentBerechtigungMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungMultiRequest was null or undefined when calling postDokumentBearbeitenBerechtigungHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/bearbeiten/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/entfernen
     * @param dokumentBerechtigungRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRequest === null || dokumentBerechtigungRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRequest was null or undefined when calling postDokumentBerechtigungEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungEntfernenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/entfernen/multi
     * @param dokumentBerechtigungMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungEntfernenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungMultiRequest === null || dokumentBerechtigungMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungMultiRequest was null or undefined when calling postDokumentBerechtigungEntfernenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/entfernen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/hinzufuegen
     * @param dokumentBerechtigungRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegen(dokumentBerechtigungRequest: DokumentBerechtigungRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungRequest === null || dokumentBerechtigungRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungRequest was null or undefined when calling postDokumentBerechtigungHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentBerechtigungHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/hinzufuegen/multi
     * @param dokumentBerechtigungMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungMultiRequest === null || dokumentBerechtigungMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungMultiRequest was null or undefined when calling postDokumentBerechtigungHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentEntfernen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/entfernen
     * @param dokumentEntfernenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentEntfernen(dokumentEntfernenRequest: DokumentEntfernenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentEntfernenRequest === null || dokumentEntfernenRequest === undefined) {
            throw new Error('Required parameter dokumentEntfernenRequest was null or undefined when calling postDokumentEntfernen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentEntfernenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentHinzufuegen
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerBenutzerKeinAdmin: (VeranstaltungBenutzerKeinAdmin) 
     * @endpoint post /api/ver/command/dokumente/v1/hinzufuegen
     * @param dokumentHinzufuegenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentHinzufuegen(dokumentHinzufuegenRequest: DokumentHinzufuegenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentHinzufuegenRequest === null || dokumentHinzufuegenRequest === undefined) {
            throw new Error('Required parameter dokumentHinzufuegenRequest was null or undefined when calling postDokumentHinzufuegen.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/hinzufuegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentHinzufuegenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentLeseBerechtigungHinzufuegenMulti
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/berechtigung/lesen/hinzufuegen/multi
     * @param dokumentBerechtigungMultiRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentLeseBerechtigungHinzufuegenMulti(dokumentBerechtigungMultiRequest: DokumentBerechtigungMultiRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentBerechtigungMultiRequest === null || dokumentBerechtigungMultiRequest === undefined) {
            throw new Error('Required parameter dokumentBerechtigungMultiRequest was null or undefined when calling postDokumentLeseBerechtigungHinzufuegenMulti.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/berechtigung/lesen/hinzufuegen/multi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentBerechtigungMultiRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostDokumentUploadAktualisieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerDokumentNichtGefunden: (VeranstaltungDokumentNichtGefunden) * VerDokumentEntfernt: (VeranstaltungDokumentEntfernt) * VeranstaltungNichtVeroeffentlicht: (VeranstaltungNichtVeroeffentlicht) * VeranstaltungBeendet: (VeranstaltungBeendet) * VeranstaltungGeloescht: (VeranstaltungGeloescht) * VerDokumentBenutzerDarfNichtBearbeiten: (VeranstaltungDokumentBenutzerDarfNichtBearbeiten) 
     * @endpoint post /api/ver/command/dokumente/v1/uploadaktualisieren
     * @param dokumentUploadAktualisierenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DokumentIdentifier>;
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DokumentIdentifier>>;
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DokumentIdentifier>>;
    public postDokumentUploadAktualisieren(dokumentUploadAktualisierenRequest: DokumentUploadAktualisierenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (dokumentUploadAktualisierenRequest === null || dokumentUploadAktualisierenRequest === undefined) {
            throw new Error('Required parameter dokumentUploadAktualisierenRequest was null or undefined when calling postDokumentUploadAktualisieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/dokumente/v1/uploadaktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DokumentIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: dokumentUploadAktualisierenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
